import React from 'react';
import PolicyPageLayout from '../components/PolicyPageLayout';

const Copyright = () => {
  const sections = [
    {
      title: 'Copyright Notice',
      content: 'All content published in the Federal University Wukari Journal of Agriculture and Life Sciences (FUWJALS) is protected by copyright. Authors retain copyright ownership of their published articles while granting the journal certain rights for publication and distribution.'
    },
    {
      title: 'Author Rights',
      content: 'Authors retain the following rights:',
      list: [
        'Copyright ownership of their work',
        'Right to use their work for educational and research purposes',
        'Right to post the accepted version in institutional repositories',
        'Right to create derivative works with proper attribution',
        'Right to use their work in future publications with proper citation'
      ]
    },
    {
      title: 'Journal Rights',
      content: 'By publishing with FUWJALS, authors grant the journal:',
      list: [
        'Non-exclusive right to publish and distribute the work',
        'Right to create electronic versions and formats',
        'Right to include the work in indexing services',
        'Right to authorize third-party distribution'
      ]
    },
    {
      title: 'Use and Attribution',
      content: (
        <>
          <p>All published articles are made available under an open access license that allows users to:</p>
          <ul className="section-list">
            <li>Read, download, and share the work</li>
            <li>Use the work for non-commercial purposes</li>
            <li>Create derivative works with proper attribution</li>
          </ul>
          <p>Proper attribution must include the original publication details, author names, article title, journal name, and publication date.</p>
        </>
      )
    },
    {
      title: 'Copyright Infringement',
      content: (
        <>
          <p>FUWJALS takes copyright infringement seriously. All submitted manuscripts are checked for originality using plagiarism detection software. Any instances of copyright infringement will result in immediate rejection and may lead to further action.</p>
          <p>If you believe your copyright has been infringed, please contact the editorial office immediately with details of the alleged infringement.</p>
        </>
      )
    },
    {
      title: 'Contact for Copyright Issues',
      content: 'For questions or concerns regarding copyright, please contact:',
      highlight: (
        <>
          <strong>Editorial Office</strong><br />
          Email: copyright@fuwukari.edu.ng<br />
          Phone: +234 XXX XXX XXXX
        </>
      )
    }
  ];

  return (
    <PolicyPageLayout
      title="Copyright Policy"
      sections={sections}
      icon="©"
    />
  );
};

export default Copyright;